import TileV2GraphqlManager from './Tile.v2GraphqlManager'

export default TileV2GraphqlManager
// eslint-disable-next-line import/export
export * from './Tile.v2GraphqlManager'
